import { DateTime } from 'luxon'

import { useAppContext } from '@/client/context/app'
import type { ProgramSlugWithIterations } from '@/client/services/programs/constants'
import { getProgramIterationOpenForRegistration } from '@/client/services/programs/getProgramIterationHelpers'
import type { ProgramIteration } from '@/client/services/programs/types'

export default function useProgramIterationOpenForRegistration({
  type,
  programSlug,
}: {
  type: 'learner' | 'tutor'
  programSlug: ProgramSlugWithIterations | null
}): ProgramIteration | null {
  const { requestTimestamp } = useAppContext()

  if (programSlug == null) {
    return null
  }

  return getProgramIterationOpenForRegistration(
    programSlug,
    type,
    DateTime.fromISO(requestTimestamp, { zone: 'utc' })
  )
}
